module.exports = __webpack_public_path__ + "media/images/og-saska-kepa-04137eba80c72726a0931dbc6354b98d.jpg";